module.exports = __webpack_public_path__ + "img/4_86.f9cfbd58.png";